import { BaseEntity } from "yt-ng-framework";

export class KozDokument extends BaseEntity{

    constructor(){
        super();
    }
    PodVrstaDokumentaStavkaID: number = null;
    Broj: string = null;
    Datum: Date = null;
    KomitentID: number = null;
    Napomena: string = null;
    TarifaID: number = null;
    Url: string = null;
    BrojDokumenta: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.KomitentID = input.KomitentID;
        this.Napomena = input.Napomena;
        this.TarifaID = input.TarifaID;
        this.BrojDokumenta = input.BrojDokumenta;
        return this;
    }

    Serialize(input: KozDokument){
        return input;
    }

    GetInstance(){
        return this;
    }
}